/* ISAMOR · preparación fija de 2 días naturales + tránsito en días hábiles. */
const existingDeliveryRuntime = window.ISAMORDeliveryEstimate;
if (existingDeliveryRuntime) {
  existingDeliveryRuntime.initAll(document);
} else {
  const TZ = 'America/Mexico_City';
  const CUTOFF_SECONDS = 18 * 60 * 60;
  const EXTRA_HOLIDAYS = new Set([]);
  const METHOD_SELECTOR = 'input[type="radio"][data-isamor-delivery-method]';

  const parts = (d = new Date()) => Object.fromEntries(
    new Intl.DateTimeFormat('en-CA', {
      timeZone: TZ,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(d).filter((p) => p.type !== 'literal').map((p) => [p.type, p.value])
  );
  const dateUTC = (p) => new Date(Date.UTC(+p.year, +p.month - 1, +p.day));
  const addDays = (d, n) => {
    const x = new Date(d);
    x.setUTCDate(x.getUTCDate() + n);
    return x;
  };
  const fmt = (d) => new Intl.DateTimeFormat('es-MX', { day: 'numeric', month: 'long', timeZone: 'UTC' }).format(d);
  const iso = (d) => [d.getUTCFullYear(), String(d.getUTCMonth() + 1).padStart(2, '0'), String(d.getUTCDate()).padStart(2, '0')].join('-');
  const same = (a, b) => a.getUTCFullYear() === b.getUTCFullYear() && a.getUTCMonth() === b.getUTCMonth() && a.getUTCDate() === b.getUTCDate();
  const nth = (y, m, w, n) => {
    const f = new Date(Date.UTC(y, m, 1));
    const delta = (w - f.getUTCDay() + 7) % 7;
    return new Date(Date.UTC(y, m, 1 + delta + (n - 1) * 7));
  };
  const holiday = (d) => {
    const y = d.getUTCFullYear(), m = d.getUTCMonth(), day = d.getUTCDate();
    if (EXTRA_HOLIDAYS.has(iso(d))) return true;
    if ((m === 0 && day === 1) || (m === 4 && day === 1) || (m === 8 && day === 16) || (m === 11 && day === 25)) return true;
    if (same(d, nth(y, 1, 1, 1)) || same(d, nth(y, 2, 1, 3)) || same(d, nth(y, 10, 1, 3))) return true;
    return y >= 2024 && (y - 2024) % 6 === 0 && m === 9 && day === 1;
  };
  const business = (d) => {
    const w = d.getUTCDay();
    return w !== 0 && w !== 6 && !holiday(d);
  };
  const addBusiness = (d, n) => {
    const x = new Date(d);
    let c = 0;
    while (c < n) {
      x.setUTCDate(x.getUTCDate() + 1);
      if (business(x)) c++;
    }
    return x;
  };
  const range = (r) => {
    const a = parseInt((r && r.dataset.minDays) || '1', 10);
    const b = parseInt((r && r.dataset.maxDays) || String(a), 10);
    const x = Number.isFinite(a) ? Math.max(1, a) : 1;
    const y = Number.isFinite(b) ? Math.max(1, b) : x;
    return { min: Math.min(x, y), max: Math.max(x, y) };
  };
  const rangeLabel = ({ min, max }) => {
    if (min === max) return `${min} ${min === 1 ? 'día hábil' : 'días hábiles'}`;
    return `${min}–${max} días hábiles`;
  };

  function init(root) {
    if (!(root instanceof HTMLElement)) return;
    if (root.closest('.quick-add-modal')) return;

    const msg = root.querySelector('[data-delivery-message]');
    const order = root.querySelector('[data-order-date]');
    const readyEl = root.querySelector('[data-ready-date]');
    const arrival = root.querySelector('[data-arrival-date]');
    const getRadios = () => [...root.querySelectorAll(METHOD_SELECTOR)];
    if (!msg || !order || !readyEl || !arrival || !getRadios().length) return;

    if (root.dataset.isamorDeliveryReady === 'true' && typeof root.isamorDeliveryRender === 'function') {
      root.isamorDeliveryRender();
      return;
    }

    root.dataset.isamorDeliveryReady = 'true';
    root.dataset.ready = 'true';

    function render() {
      const radios = getRadios();
      if (!radios.length) return;

      root.style.setProperty('--isamor-delivery-method-count', String(radios.length));

      radios.forEach((radio) => {
        const label = radio.closest('.isamor-delivery__method')?.querySelector('small');
        if (label) label.textContent = rangeLabel(range(radio));
      });

      const p = parts();
      const base = dateUTC(p);
      const seconds = (+p.hour * 3600) + (+p.minute * 60) + (+p.second);
      /* Antes de las 18:00 cuenta el día actual; desde las 18:00 la preparación inicia al día natural siguiente. */
      const preparationStart = seconds >= CUTOFF_SECONDS ? addDays(base, 1) : base;
      const ready = addDays(preparationStart, 2);
      const selected = radios.find((radio) => radio.checked) || radios[0];
      if (!selected.checked) selected.checked = true;
      const method = range(selected);
      const amin = addBusiness(ready, method.min);
      const amax = addBusiness(ready, method.max);

      order.textContent = fmt(base);
      readyEl.textContent = fmt(ready);
      arrival.textContent = same(amin, amax) ? fmt(amin) : `${fmt(amin)}–${fmt(amax)}`;
      msg.innerHTML = `Tu pedido estará <strong>listo para envío el ${fmt(ready)}</strong>.`;
      root.dataset.state = 'ready';
    }

    root.isamorDeliveryRender = render;
    root.addEventListener('change', (event) => {
      if (event.target instanceof HTMLInputElement && event.target.matches(METHOD_SELECTOR)) render();
    });
    render();

    const timer = setInterval(() => {
      if (!root.isConnected) {
        clearInterval(timer);
        return;
      }
      render();
    }, 60000);
  }

  function initAll(scope = document) {
    if (scope instanceof Element && scope.matches('[data-isamor-delivery]')) init(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-isamor-delivery]').forEach(init);
  }

  function refresh(scope = document) {
    const roots = [];
    if (scope instanceof Element && scope.matches('[data-isamor-delivery]')) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll('[data-isamor-delivery]'));

    [...new Set(roots)].forEach((root) => {
      if (typeof root.isamorDeliveryRender === 'function') root.isamorDeliveryRender();
      else init(root);
    });
  }

  window.ISAMORDeliveryEstimate = { init, initAll, refresh };
  initAll(document);

  document.addEventListener('shopify:product:select', (event) => {
    if (!event.promise || typeof event.promise.then !== 'function') return;

    event.promise
      .then(() => initAll(document))
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          console.warn('[ISAMOR delivery] No se pudo refrescar tras cambiar producto/variante.', error);
        }
      });
  });

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target instanceof Element ? event.target : document);
  });
}
